'use client';
import { useEffect } from 'react';

const NotFound = () => {
	useEffect(() => {
		typeof window !== 'undefined' ? window.location.replace('/') : '';
	}, []);

	return null;
};

export default NotFound;
